module.exports = [
    {
        "title": "公司地址",
        "contents": [
            {
                "text": "北京市朝阳区酒仙桥北路甲10号院105号楼"
            }
        ]
    },
    {
        "title": "联系电话",
        "contents": [
            {
                "text": "如果您在使用钱柜的过程中有任何疑问请您与客服人员联系"
            },
            {
                "text": "客服热线：10105800，工作时间：周一到周日 9:00-18:00"
            }
        ]
    },
    {
        "title": "电子邮箱",
        "contents": [
            {
                "text": "客服咨询：qianguikefu@58.com"
            },
            {
                "text": "投诉建议：qianguikefu@58.com"
            }
        ]
    },
    {
        "title": "互联网金融举报信息平台地址",
        "contents": [
            {
                "text": "https://jubao.nifa.org.cn/ipnifa/index.html"
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/config/InfoDcs/Basic.js